import React from 'react';
import {Input, Form, DatePicker, Button, Row, Col, Icon} from 'antd';
import {RemoveEmptyEle,removePropertyOfNull} from '../../../utils';


const { TextArea } = Input;
const { RangePicker } = DatePicker;
const Render =({form,onFinish})=>{

	const formLargeItemLayout = {
		labelCol: {
			span: 4,
		},
		wrapperCol: {
			span: 18,
		},
	}

	const  handleSubmit =(e)=>{
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				//清空一下空数据				
				onFinish(removePropertyOfNull(values));
			}
		});
	}
	return (
		<Form  {...formLargeItemLayout}  >

			<Row gutter={24} >

				<Col span={5} >

					<Form.Item

						label='客户'
					>
						{form.getFieldDecorator('enterprise_name', {
						})(
						<Input placeholder="客户名称" />
						)}
					</Form.Item>

				</Col>
				<Col span={7} >
					<Form.Item

						label='代码'
					>
						{form.getFieldDecorator('social_credit_code', {
						})(
							<Input placeholder="社会信用代码" />
						)}

					</Form.Item>
				</Col>
				<Col span={5} >
					<Form.Item

						label='状态'
					>
						{form.getFieldDecorator('status', {
						})(
							<Input placeholder="状态" />
						)}

					</Form.Item>
				</Col>
				<Col span={2}  >
					<Button type="primary" onClick ={handleSubmit}>   <Icon type="search" /> 查询</Button>
				</Col>
			</Row>

      </Form>

	)

}



const SearchRender = Form.create()(Render);


export default SearchRender;
